<button class="vc-btn vc-btn--large vc-btn--full vc-btn__facebook-connect" (click)="openFacebookConnect()">
  <span class="vc-btn__facebook-connect__icon">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M-1 -0.5V20.5H8.68293V13.1607H6.3159V10.1646H8.68293V7.64839C8.68293 5.81843 10.1025 4.33497 11.8537 4.33497H14.3282V7.02915H12.5575C12.0011 7.02915 11.55 7.50055 11.55 8.08202V10.1646H14.2837L13.9059 13.1607H11.55V20.5H21V-0.5H-1Z"
        fill="#1A77F2"
      />
    </svg>
  </span>
  <span class="vc-btn__facebook-connect__text" i18n="@@FACEBOOK.CONNECT.BUTTON">Continue with Facebook</span>
</button>
